import { auditReports } from '@mi-front/api-clients';
import { Chip, ChipProps } from '@mui/material';
import { IntlFormatters, useIntl } from 'react-intl';

interface Props {
  run: {
    status: auditReports.AodRunStatusEnumKey;
    efficiency?: number;
  };
  size?: ChipProps['size'];
  showEfficiency?: boolean;
}

export const getStatusLabel = (
  $t: IntlFormatters['$t'],
  status: auditReports.AodRunStatusEnumKey,
) => {
  switch (status) {
    case auditReports.AodRunStatusEnum.COMPLETED_WITH_EXPORT:
      return $t({
        id: 'audit.aod.runs.status.completed_with_export',
        defaultMessage: 'Ejecutada con export',
      });
    case auditReports.AodRunStatusEnum.COMPLETED_WITHOUT_EXPORT:
      return $t({
        id: 'audit.aod.runs.status.completed_without_export',
        defaultMessage: 'Ejecutada sin export',
      });
    case auditReports.AodRunStatusEnum.WAITING:
      return $t({
        id: 'audit.aod.runs.status.pending',
        defaultMessage: 'Pendiente',
      });
    case auditReports.AodRunStatusEnum.IN_PROGRESS:
      return $t({
        id: 'audit.aod.runs.status.in_progress',
        defaultMessage: 'En progreso',
      });
    case auditReports.AodRunStatusEnum.WAITING_FOR_REPROCESS:
      return $t({
        id: 'audit.aod.runs.status.waiting_for_reprocess',
        defaultMessage: 'Esperando reproceso',
      });
    case auditReports.AodRunStatusEnum.FAILED:
      return $t({
        id: 'audit.aod.runs.status.failed',
        defaultMessage: 'Error',
      });
    default:
      return status;
  }
};

export function AodRunStatus({ run, size = 'small', showEfficiency = true }: Props) {
  const { $t } = useIntl();
  const { status } = run;

  const isInCompletedStatus =
    status === auditReports.AodRunStatusEnum.COMPLETED_WITH_EXPORT ||
    status === auditReports.AodRunStatusEnum.COMPLETED_WITHOUT_EXPORT;

  const getStatusColor = (status: auditReports.AodRunStatusEnumKey) => {
    switch (status) {
      case auditReports.AodRunStatusEnum.COMPLETED_WITH_EXPORT:
        return 'success';
      case auditReports.AodRunStatusEnum.COMPLETED_WITHOUT_EXPORT:
        return 'warning';
      case auditReports.AodRunStatusEnum.WAITING:
      case auditReports.AodRunStatusEnum.IN_PROGRESS:
      case auditReports.AodRunStatusEnum.WAITING_FOR_REPROCESS:
        return 'info';
      case auditReports.AodRunStatusEnum.FAILED:
        return 'error';
      default:
        return 'default';
    }
  };

  const getLabel = () => {
    const baseLabel = getStatusLabel($t, status);

    if (showEfficiency && isInCompletedStatus) {
      return `${baseLabel} (${Math.floor(run.efficiency ?? 0)}%)`;
    }

    return baseLabel;
  };

  return <Chip label={getLabel()} color={getStatusColor(status)} size={size} />;
}
